import { NgModule } from "@angular/core";
import { ProfileComponent } from "./profile.component";
import { AdminCommonModule } from "../../admin/admin-common.module";

@NgModule({
    declarations: [
        ProfileComponent
    ],
    imports: [
        AdminCommonModule
    ]
})
export class ProfileModule {
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/account/profile/profile.module.ts